exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1TKIQ4ejepxKh8 .js-react-root{display:inline}", ""]);

// exports
exports.locals = {
	"reactRootWrapper": "_1TKIQ4ejepxKh8"
};